// @flow
import * as React from 'react'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { colors } from '@components/shared'
import { getBackground } from '../helpers'
import SharedCta from '../SharedCta'
import { RichTextContainer } from './sectionStyles'
import type {
  BackgroundColorType,
  CtaDataType
} from '../../../services/contentfulMarketingLandingPages'
import type { BackgroundType } from '../helpers'

const options = {
  renderNode: {
    [MARKS.CODE]: (node: any, children: any): React.Node => {
      return <div dangerouslySetInnerHTML={{ __html: children }} />
    },
    'embedded-asset-block': (node: any): React.Node => {
      return <img src={node.data.target.fields.file.url} />
    }
  }
}

export const CtaCard = (props: {
  bottomCardBackgroundColor: BackgroundColorType,
  bottomCardBackgroundImage: string | null,
  bottomCardText: string | null,
  bottomCardCta: CtaDataType | null
}): React.Node => {
  const { bottomCardBackgroundColor, bottomCardBackgroundImage, bottomCardText, bottomCardCta } = props
  const sectionBackground: BackgroundType = getBackground(
    bottomCardBackgroundColor,
    bottomCardBackgroundImage
  )

  const text = documentToReactComponents(bottomCardText, options)

  return (
    <Card
      backgroundColor={
        sectionBackground.backgroundImageUrl
          ? 'unset'
          : sectionBackground.backgroundColor
      }
      backgroundImageUrl={sectionBackground.backgroundImageUrl}
    >
      <ContentContainer>
        <BodyTextWrapper>
          {text}
        </BodyTextWrapper>

        {!!bottomCardCta &&
          <SharedCta cta={bottomCardCta} />
        }
      </ContentContainer>
    </Card>
  )
}

const BodyTextWrapper = styled(RichTextContainer)`
  color: ${colors.white};
  p {
    text-align: center;
    margin: 0 0 1.5em;
  }
`
const Card = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 15px;
  max-width: 800px;
  position: relative;
  width: 100%;
  margin: 0 0 20px;
  ${(props: any): ?string => {
    if (props.backgroundImageUrl) {
      return `background-image: url(${props.backgroundImageUrl});`
    } else if (props.backgroundColor) {
      return `background-color: ${props.backgroundColor};`
    }
  }}
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 24px 12px;
  ${(props: any): string => config(props).media.md`
    align-items: center;
    padding: 28px 36px;
  `}

  button {
    margin: 0 0 14px;
  }
`
